// Layout breakpoints (px)
export const BREAKPOINT_NARROW = 480;
export const BREAKPOINT_COMPACT = 768;

// Default fallback dimensions when container hasn't measured yet (px)
export const DEFAULT_CHART_WIDTH = 960;
export const DEFAULT_CHART_HEIGHT = 560;

// Trace thinning: reduce stroke count to avoid visual clutter.
// Each entry means "if count <= maxStrokes, show every `step`-th stroke."
export const THINNING_THRESHOLDS = [
  { maxStrokes: 15, step: 1 },
  { maxStrokes: 60, step: 3 },
  { maxStrokes: 100, step: 5 },
  { maxStrokes: Infinity, step: 8 },
] as const;

// Ghost (background) line opacity
export const GHOST_OPACITY = 0.16;

// Profile (session average) line stroke width
export const PROFILE_STROKE_WIDTH = 3.6;

// Zoom constraints
export const ZOOM_SCALE_EXTENT: [number, number] = [1, 12];

// Playback
export const DEFAULT_ANIMATION_DURATION_MS = 28_000;
export const PLAYBACK_SPEEDS = [0.5, 1, 2, 3] as const;

// Domain defaults (gate angle in degrees, force in kgf)
export const DEFAULT_ANGLE_DOMAIN: [number, number] = [-95, 55];
export const DEFAULT_FORCE_DOMAIN: [number, number] = [-20, 120];

// Y-domain padding: proportional factor and absolute floor
export const DOMAIN_PAD_FACTOR = 0.12;
export const DOMAIN_PAD_MIN = 6;
export const MIN_Y_SPAN = 24;

// Progress bar stroke-marker cap (avoids a wall of dots on long sessions)
export const MAX_STROKE_MARKERS = 60;

// Dash patterns by rower seat number (index 0 = solid, then increasingly dashed)
export const ROWER_DASH_PATTERNS: (string | null)[] = [null, '8 4', '4 3', '2 3'];
